export var withScrollIntoView = function withScrollIntoView(command) {
  return function (state, dispatch, view) {
    return command(state, function (tr) {
      tr.scrollIntoView();
      if (dispatch) {
        dispatch(tr);
      }
    }, view);
  };
};